<template>
    <section class="assessmentSection checkoutSection">
        <div class="checkoutSummaryBar">
            <div class="total"> Total: {{ system.discountedTotalFormatted }} </div>
            <a href="javascript:;" class="view" @click="viewDetails"> View details </a>
        </div>
        <div class="checkoutContainer">
            <CheckoutHeader :current-page="currentPage" />
            <div class="checkoutBody">
                <div class="checkoutOverview">
                    <slot />
                </div>
                <!-- RIGHT COLUMN -->
                <CheckoutSummary />
                <!-- END RIGHT COLUMN -->
            </div>
        </div>
    </section>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import CheckoutHeader from './CheckoutHeader.vue'
import CheckoutSummary from './CheckoutSummary.vue'
import $ from 'jquery'
export default {
    props: ['current-page'],
    data() {
        return {
            navInstallAndMonitoring: true,
            navPersonalInfo: false,
            navPaymentInfo: false
        }
    },
    computed: {
        ...mapState(['monitoringFrequencyVisible', 'system'])
    },
    methods: {
        ...mapActions(['updateSystem', 'toggleMonitoringFrequencyVisible']),
        goBack() {
            this.$router.go(-1)
        },
        
        viewDetails() {
            let el = $('.checkoutSummary')
            scrollToContent(el, -100)
        }
    },
    components: {
        CheckoutHeader,
        CheckoutSummary
    },
    mounted() {
        this.updateSystem()
    }
}
</script>

<style lang="css"></style>
